module.exports = __webpack_public_path__ + "static/media/parceiros.f727f221.png";